/**
 * Extracts the user-entered order details text from a composed ticket description.
 * Returns '' when no "Order details:" section is found, because the absence of the
 * marker means no user notes were entered — the description contains only
 * auto-generated device/address sections that must not be re-injected as user notes.
 */
export function extractOrderDetailsFromDescription(
  description: string,
  orderDetailsLabel: string
): string {
  if (!description?.trim()) {
    return ''
  }
  const marker = `${orderDetailsLabel}:`
  const idx = description.indexOf(marker)
  if (idx === -1) {
    return ''
  }
  const after = description.slice(idx + marker.length).replace(/^\s*\n/, '')
  const sectionBreak = after.search(/\n\n[^\n]+:/)
  if (sectionBreak === -1) {
    return after.trim()
  }
  return after.slice(0, sectionBreak).trim()
}
